import {
  useGetMSChangeLogList,
  useGetMSUsers,
  useGetProgramChangeLogList,
  useGetProgramUsers,
} from './useChangelog'

export const changelog = {
  getPrograms: useGetProgramChangeLogList,
  getProgramUsers: useGetProgramUsers,
  getSpecialists: useGetMSChangeLogList,
  getSpecialistUsers: useGetMSUsers,
}
